module.exports = __webpack_public_path__ + "07_bob_brown.971ed308.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/07_bob_brown.png
// module id = cQbD
// module chunks = 0